import { render, staticRenderFns } from "./modalCadastro.vue?vue&type=template&id=064905d1&scoped=true"
import script from "./modalCadastro.vue?vue&type=script&lang=js"
export * from "./modalCadastro.vue?vue&type=script&lang=js"
import style0 from "./modalCadastro.vue?vue&type=style&index=0&id=064905d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064905d1",
  null
  
)

export default component.exports